

export const translateInViewVariant = {
    initial: {
      opacity: 0,
      y: 90,
      // height: '10px'
    },
    whileInview: {
      opacity: 1,
      y: 0,
      // height: 'auto',

    },
  }